import React from 'react';
import { mockFDs, formatCurrency } from '../../../services/mockData';

const FDRegister = () => {
  const totalInvested = mockFDs.reduce((s, f) => s + f.amount, 0);
  const totalMaturity = mockFDs.reduce((s, f) => s + f.maturityAmount, 0);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Registers <span>/ FD Register</span></div>
        <h2>FD Register</h2>
      </div>

      <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
        <div className="stat-card" style={{ flex: 1 }}>
          <div className="stat-icon blue">💰</div>
          <div className="stat-info">
            <div className="stat-value">₹{formatCurrency(totalInvested)}</div>
            <div className="stat-label">Total Invested Amount</div>
          </div>
        </div>
        <div className="stat-card" style={{ flex: 1, borderLeftColor: '#2ec4b6' }}>
          <div className="stat-icon green">📈</div>
          <div className="stat-info">
            <div className="stat-value">₹{formatCurrency(totalMaturity)}</div>
            <div className="stat-label">Total Maturity Amount</div>
          </div>
        </div>
        <div className="stat-card" style={{ flex: 1, borderLeftColor: '#ff9f1c' }}>
          <div className="stat-icon orange">🏦</div>
          <div className="stat-info">
            <div className="stat-value">{mockFDs.length}</div>
            <div className="stat-label">Total FDs</div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">FD Report</span>
          <button className="btn btn-warning btn-sm">🖨️ Print</button>
        </div>

        <div className="report-header" style={{ marginBottom: '16px' }}>
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>FD Register 2025-2026 On dated: 2026-02-02</p>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>FDR No.</th>
                <th>FD Date</th>
                <th>Bank Name</th>
                <th className="amount">Amount (₹)</th>
                <th>FD Type</th>
                <th>Month</th>
                <th>Int @</th>
                <th>Effective Date</th>
                <th>Maturity Date</th>
                <th className="amount">Maturity Amount</th>
              </tr>
            </thead>
            <tbody>
              {mockFDs.map((f, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: '600' }}>{f.fdNo}</td>
                  <td>{f.fdDate}</td>
                  <td>{f.bankName}</td>
                  <td className="amount">{formatCurrency(f.amount)}</td>
                  <td><span className="badge badge-primary">{f.fdType}</span></td>
                  <td>{f.months}</td>
                  <td>{f.interestRate}%</td>
                  <td>{f.effectiveDate}</td>
                  <td>{f.maturityDate}</td>
                  <td className="amount cr" style={{ fontWeight: '700' }}>{formatCurrency(f.maturityAmount)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3} style={{ textAlign: 'right', fontWeight: '800' }}>Invested Amount</td>
                <td className="amount" style={{ fontWeight: '800', color: '#4361ee' }}>₹{formatCurrency(totalInvested)}</td>
                <td colSpan={5} style={{ textAlign: 'right', fontWeight: '800' }}>Maturity Amount</td>
                <td className="amount" style={{ fontWeight: '800', color: '#2ec4b6' }}>₹{formatCurrency(totalMaturity)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FDRegister;
